import PropTypes from "prop-types";
import { LAST_SEARCH } from "../../../../constants/common/common";
import Chip from "../../../atoms/chip";
import Typography from "../../../atoms/typography";

/**
 * RecentSearch component displays a list of recent search keywords.
 * It allows users to either navigate to a recent search or remove it from the list.
 *
 * @param {Object} props - Component properties.
 * @param {Array} props.recentSearch - The list of recent search keywords and URLs.
 * @param {Function} props.setRecentSearch - Function to update the recent search list in the parent component.
 *
 * @returns {JSX.Element} The rendered RecentSearch component.
 */
const OldRecentSearch = ({ recentSearch, setRecentSearch, onSearchTrackEvent, onNavigate = () => {} }) => {
  /**
   * Redirects the user to the selected recent search URL.
   *
   * @param {string} url - The URL to navigate to.
   */
  const onRedirectToRecentSearch = (url) => {
    onNavigate();
    window.location.href = url;
  };

  /**
   * Removes a specific recent search from the list and updates localStorage.
   *
   * @param {Event} event - The event triggered when the close icon is clicked.
   * @param {number} removedItem - The index of the item to be removed from the recent search list.
   */
  const onRemoveRecentSearch = (event, removedItem) => {
    event.stopPropagation(); // Prevent the click event from bubbling up
    const newArr = recentSearch.filter((item) => item.keyword !== removedItem);
    const recentSearchList = { recentSearchList: newArr };
    localStorage.setItem("recentSearchList", JSON.stringify(recentSearchList));
    setRecentSearch(newArr); // Update the parent state with the new recent search list
  };

  return (
    <div className="flex w-full flex-col border-b-2 border-white p-16">
      <Typography variant="p" Tag="p" classes="font-500 text-14 text-black-100">
        {LAST_SEARCH}
      </Typography>
      <div className="mt-8 flex w-full flex-wrap gap-8">
        {recentSearch?.map((item) => (
          <Chip
            key={item.keyword}
            id="test"
            size="medium"
            content={item.keyword}
            color="default"
            variant="default"
            classes="bg-white-900 text-grey-500 capitalize text-12"
            startIcon="/icons/search-normal.svg"
            endIcon="/icons/Close.svg"
            onClose={(e) => onRemoveRecentSearch(e, item.keyword)}
            // eslint-disable-next-line react/jsx-handler-names
            onClick={() => {
              onRedirectToRecentSearch(item.url);
              onSearchTrackEvent(item.keyword, item);
            }}
          />
        ))}
      </div>
    </div>
  );
};
OldRecentSearch.propTypes = {
  recentSearch: PropTypes.arrayOf(
    PropTypes.shape({
      keyword: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ).isRequired,
  setRecentSearch: PropTypes.func.isRequired,
  onSearchTrackEvent: PropTypes.func,
  onNavigate: PropTypes.func,
};
export default OldRecentSearch;
